/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {

    export class ManageClaimsModel {
        private systemLevel: Wars.Domain.Model.SystemLevel;

        public newSystemClaim: Wars.Domain.Model.ClaimDefinition;
        public existingSystemClaims: Wars.Domain.Model.ClaimDefinition[];
        public existingCodeGroups: Wars.Domain.Model.Codes.CodeGroup[];
        public optionalUserRepositories: string[];
        public existingUserRepositories: Wars.Domain.Model.UserRepositoryConfiguration[];
        public isMapped: boolean;
        public seletedUserRepo: string;

        constructor(
            private claimDefinitionService: services.ClaimDefinitionService,
            private systemLevelService: services.SystemLevelService,
            private deleteService: services.DeleteService,
            private modalService: any) {
            var self = this;
            self.existingSystemClaims = [];
            self.getExistingSystemClaims();
            self.existingCodeGroups = [];
            self.getExistingCodeGroups();
            self.optionalUserRepositories = [];
            self.existingUserRepositories = [];
            self.isMapped = false;
            self.seletedUserRepo = "";
            self.systemLevelService.getUserRepositoryConfigurations().then(
                (systemLevel) => {
                    self.existingUserRepositories.addRange(systemLevel.myUserRepositoryConfigurations);
                    self.claimDefinitionService.getUserRepositoryComponents()
                        .then((result) => {
                        for (var i = 0; i < result.length; i++) {
                            if (!Enumerable.from(self.existingUserRepositories).any(x => x.userRepositoryComponentTag === result[i])) {
                                self.optionalUserRepositories.push(result[i]);
                            }
                        }
                });
            });
        }

        private getExistingSystemClaims(): void {
            var self = this;
            this.systemLevelService.getSystemLevelClaimsWithGrantAuthorizations().then(
                (systemLevel) => {
                    self.systemLevel = systemLevel;
                    self.existingSystemClaims = systemLevel.myClaims;
                });
        }

        private getExistingCodeGroups(): void {
            var self = this;
            this.systemLevelService.getSystemLevelCodes().then(
                (systemLevel) => {
                    self.systemLevel = systemLevel;
                    self.existingCodeGroups = systemLevel.myCodeGroups;
                });
        }

        public addUserRepo(): void {
            var self = this;
            var ur = self.claimDefinitionService.createNewEntity<Wars.Domain.Model.UserRepositoryConfiguration>("UserRepositoryConfiguration");
            ur.systemLevel_id = self.systemLevel.id;
            ur.userRepositoryComponentTag = self.seletedUserRepo;
            self.claimDefinitionService.saveAllChanges(() => {
                self.existingUserRepositories.push(ur);
                self.optionalUserRepositories = Enumerable.from(self.optionalUserRepositories).where(i => i !== self.seletedUserRepo).toArray();
                self.seletedUserRepo = "";    
            });
        }

        public deleteUserRepo(userRepo: Wars.Domain.Model.UserRepositoryConfiguration): void {
            var self = this;
            var tag = userRepo.userRepositoryComponentTag;
            userRepo.entityAspect.setDeleted();
            self.claimDefinitionService.saveAllChanges(() => {
                self.existingUserRepositories = Enumerable.from(self.existingUserRepositories).where(i => i.id !== userRepo.id).toArray();
                self.optionalUserRepositories.push(tag);
            });
        }

        public addNewSystemClaim(): void {
            this.newSystemClaim = this.claimDefinitionService.createNewEntity<Wars.Domain.Model.ClaimDefinition>("ClaimDefinition");
            this.newSystemClaim.valueAssignable = false;
            this.newSystemClaim.valueType = Wars.Domain.Model.Codes.Enums.VariableType.None;
            this.newSystemClaim.uniqueIdentifier = services.UtilityService.generateGuidComb();
            this.isMapped = false;
            this.showModal(this.newSystemClaim, true);
        }

        public getGrantClaims() {
            var self = this;
            return Enumerable.from(self.existingSystemClaims)
                .where(i => (i.claimMapName == null || i.claimMapName.trim() === ""))
                .toArray();
        }

        public addClaimGrant(claim: Wars.Domain.Model.ClaimDefinition): void {
            var self = this;
            var cg = self.claimDefinitionService.createNewEntity<Wars.Domain.Model.ClaimGrantAuthority>("ClaimGrantAuthority");
            cg.claimDefinition_id = claim.id;
            cg.myClaimDefinition = claim;
            cg.systemLevel_id = claim.systemLevel_id;
            claim.claimGrantAuthorities.push(cg);
            if (claim.myCodeGroup != null) {
                for (var i = 0; i < claim.myCodeGroup.codes.length; i++) {
                    var r = self.claimDefinitionService.createNewEntity<Wars.Domain.Model.ClaimGrantRestrictionValue>("ClaimGrantRestrictionValue");
                    r.systemLevel_id = cg.systemLevel_id;
                    r.claimGrantAuthority_id = cg.id;
                    r.myClaimGrantAuthority = cg;
                    r.systemCode_id = claim.myCodeGroup.codes[i].id;
                    r.restricted = false;
                }
            }
            self.claimDefinitionService.saveAllChanges();
        }

        public removeClaimGrant(claimGrant: Wars.Domain.Model.ClaimGrantAuthority): void {
            var self = this;
            while (claimGrant.claimGrantAuthorityValues.length > 0) {
                claimGrant.claimGrantAuthorityValues[0].entityAspect.setDeleted();
            }
            while (claimGrant.claimGrantRestrictionValues.length > 0) {
                claimGrant.claimGrantRestrictionValues[0].entityAspect.setDeleted();
            }
            claimGrant.entityAspect.setDeleted();
            self.claimDefinitionService.saveAllChanges();
        }

        public updateGrantClaim(claimGrant: Wars.Domain.Model.ClaimGrantAuthority) {
            var self = this;
            var i: number;
            while (claimGrant.claimGrantAuthorityValues.length > 0) {
                claimGrant.claimGrantAuthorityValues[0].entityAspect.setDeleted();
            }
            if (claimGrant.myGrantClaimDefinition.myCodeGroup != null) {
                for (i = 0; i < claimGrant.myGrantClaimDefinition.myCodeGroup.codes.length; i++) {
                    var a = self.claimDefinitionService.createNewEntity<Wars.Domain.Model.ClaimGrantAuthorityValue>("ClaimGrantAuthorityValue");
                    a.systemLevel_id = claimGrant.systemLevel_id;
                    a.claimGrantAuthority_id = claimGrant.id;
                    a.myClaimGrantAuthority = claimGrant;
                    a.systemCode_id = claimGrant.myGrantClaimDefinition.myCodeGroup.codes[i].id;
                    a.granted = false;
                }    
            }
            self.claimDefinitionService.saveAllChanges();
        }

        public save(): void {
            var self = this;
            self.claimDefinitionService.saveAllChanges();
        }

        private transformClaim(claim: Wars.Domain.Model.ClaimDefinition): void {
            var self = this;
            if (claim.processConfiguration_id != null && claim.processConfiguration_id.trim() !== "") {
                claim.codeGroup_id = null;
                claim.myCodeGroup = null;
                claim.valueAssignable = false;
                claim.valueType = Wars.Domain.Model.Codes.Enums.VariableType.None;
            } else {
                if (self.isMapped) {
                    claim.codeGroup_id = null;
                    claim.myCodeGroup = null;
                    claim.valueAssignable = false;
                    if (claim.claimMapName == null || claim.claimMapName.trim() === "") {
                        claim.valueType = Wars.Domain.Model.Codes.Enums.VariableType.None;
                    } else {
                        claim.valueType = Wars.Domain.Model.Codes.Enums.VariableType.String;
                    }
                } else {
                    claim.claimMapName = "";
                    claim.claimMapValue = "";
                    if (claim.specialClaimTagType != null &&
                        (claim.specialClaimTagType === Wars.Domain.Model.Codes.Enums.SpecialClaimTag.SystemAdminClaim ||
                        claim.specialClaimTagType === Wars.Domain.Model.Codes.Enums.SpecialClaimTag.ConfiguratorClaim)) {
                        claim.valueType = Wars.Domain.Model.Codes.Enums.VariableType.None;
                        claim.valueAssignable = false;
                    } else {
                        if (claim.valueType == null || claim.valueType === Wars.Domain.Model.Codes.Enums.VariableType.None) {
                            claim.valueAssignable = false;
                        } else {
                            claim.valueAssignable = true;
                        }
                    }
                }
            }
        }

        public editExistingSystemClaim(claim: Wars.Domain.Model.ClaimDefinition) : void {
            this.showModal(claim, false);
        }

        public deleteClaim(claim: Wars.Domain.Model.ClaimDefinition) {
            this.deleteService.deleteWithModalConfirmIfNecessary("ClaimDefinition", claim.id, "Claim Definition", () => this.existingSystemClaims.remove(claim));
        }

        public deleteClaimGrantAuthority(claim: Wars.Domain.Model.ClaimDefinition) {
            var self = this;
            while (claim.claimGrantAuthorities.length > 0) {
                while (claim.claimGrantAuthorities[0].claimGrantAuthorityValues.length > 0) {
                    claim.claimGrantAuthorities[0].claimGrantAuthorityValues[0].entityAspect.setDeleted();
                }
                while (claim.claimGrantAuthorities[0].claimGrantRestrictionValues.length > 0) {
                    claim.claimGrantAuthorities[0].claimGrantRestrictionValues[0].entityAspect.setDeleted();
                }
                claim.claimGrantAuthorities[0].entityAspect.setDeleted();
            }
            for (var i = 0; i < self.existingSystemClaims.length; i++) {
                var c = self.existingSystemClaims[i];
                if (c === claim) continue;
                var matches = Enumerable.from(c.claimGrantAuthorities).where(x => x.grantClaimDefinition_id === claim.id).toArray();
                for (var j = 0; j < matches.length; j++) {
                    while (matches[j].claimGrantAuthorityValues.length > 0) {
                        matches[j].claimGrantAuthorityValues[0].entityAspect.setDeleted();
                    }
                    while (matches[j].claimGrantRestrictionValues.length > 0) {
                        matches[j].claimGrantRestrictionValues[0].entityAspect.setDeleted();
                    }
                    matches[j].entityAspect.setDeleted();
                }
            }
        }
        
        private showModal(claim: Wars.Domain.Model.ClaimDefinition, adding: boolean) { // Just provide a template url, a controller and call 'showModal'.
            var self: ManageClaimsModel = this;
            var variableTypeContext = new models.EnumDropDownContext();
            variableTypeContext.includeSpecifiedOptionsOnly = new Array<number>();
            variableTypeContext.includeSpecifiedOptionsOnly.push(Wars.Domain.Model.Codes.Enums.VariableType.None);
            //variableTypeContext.includeSpecifiedOptionsOnly.push(Wars.Domain.Model.Codes.Enums.VariableType.String);
            if (self.existingCodeGroups.length > 0) {
                variableTypeContext.includeSpecifiedOptionsOnly.push(Wars.Domain.Model.Codes.Enums.VariableType.Code);    
            }
            this.modalService.showModal({
                templateUrl: "./app/views/modals/_claimEditModal.html",
                controller: "editClaimModalController",
                inputs: {
                    claim: claim,
                    mapping: { isMapped: (claim.claimMapName != null && claim.claimMapName.trim() !== "") },
                    systemClaimGroups: undefined,
                    variableTypeContext: variableTypeContext,
                    codeGroups: self.existingCodeGroups,
                    processActions: null
                }
            }).then(modal => {
                // The modal object has the element built, if this is a bootstrap modal
                // you can call 'modal' to show it, if it's a custom modal just show or hide
                // it as you need to. 
                (<any>claim).variableTypeChange = () => {
                    if (claim.entityAspect.entityState.isModified()) {
                        self.deleteClaimGrantAuthority(claim);
                    }
                    if (claim.valueType === Wars.Domain.Model.Codes.Enums.VariableType.Code) {
                        if (claim.codeGroup_id == null) {
                            var defaultCode = Enumerable.from(this.existingCodeGroups).firstOrDefault();
                            if (defaultCode != null) {
                                claim.codeGroup_id = defaultCode.id;
                            }
                        }
                    } else {
                        claim.codeGroup_id = null;
                        claim.myCodeGroup = null;
                    }
                };
                (<any>claim).codeGroupChange = () => {
                    self.deleteClaimGrantAuthority(claim);
                };
                (<any>claim).mappingStatusChange = () => {
                    self.deleteClaimGrantAuthority(claim);
                    if (!self.isMapped) {
                        claim.valueType = Wars.Domain.Model.Codes.Enums.VariableType.None;
                    }
                };
                modal.element.modal();
                modal.close.then(result => {
                    if (result) {
                        if (adding) {
                            this.existingSystemClaims.push(this.newSystemClaim);
                            this.newSystemClaim.systemLevel_id = this.systemLevel.id;
                            this.newSystemClaim.mySystemLevel = this.systemLevel;
                        }
                        self.isMapped = modal.scope.mapping.isMapped;
                        self.transformClaim(claim);
                        self.claimDefinitionService.saveAllChanges();
                    } else {
                        self.claimDefinitionService.rejectChanges();
                    }
                });
            });
        }
    }
}